// Microsoft Clarity configuration — single source of truth.
// To activate: paste your Clarity Project ID below (that's the only change needed).
// Get it from https://clarity.microsoft.com → Settings → Overview.
export const CLARITY_PROJECT_ID = "xps6hla13f";

let initialized = false;

// Injects the official Microsoft Clarity snippet exactly once.
// No-op when CLARITY_PROJECT_ID is empty, so this is safe to call today.
export function initClarity() {
    if (initialized || typeof window === "undefined") return;
    if (!CLARITY_PROJECT_ID) return;
    initialized = true;

    // Guard against duplicate script injection
    if (document.querySelector('script[src*="clarity.ms/tag/"]')) return;

    (function (c, l, a, r, i, t, y) {
        c[a] =
            c[a] ||
            function () {
                (c[a].q = c[a].q || []).push(arguments);
            };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
}
